import React,{useState, useRef, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEye, faEyeSlash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import axios from 'axios'

import ValidationMessage from '../../../../../component/common/ValidationMessage';
import ButtonLoader from '../../../../../component/common/ButtonLoader';
const BusinessInfoUpdateForm = (props) => {
    const {profileData} = props;
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;
    // ----- define all state here ------- //
    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [businessLogoPreview, setBusinessLogoPreview] = useState('');
    const [profileUpdateFormData, setProfileUpdateFormData] = useState({
        business_logo : {},
        old_business_logo: {},
        business_name: "",
        business_email: "",
        primary_contact: "",
        secondary_contact: "",
        old_password: "",
        new_password: "",
        confirm_password: "",
        business_address: "",
    });
    const [profileUpdateFormError, setProfileUpdateFormError] = useState({});
    const [buttonLoader, setButtonLoader] = useState(false);

    const businessLogoInputRef = useRef(null);

    // ------- select business logo ------- //
    const selectBusinessLogoHandler = () => {
        if (businessLogoInputRef.current) {
            businessLogoInputRef.current.click();
        }
    }

    const businessLogoOnChange = (event) => {
        const businessLogoFile = event.target.files[0];
        if(businessLogoFile){
            const allowedExtensions = ['jpg', 'jpeg', 'png'];
            const fileExtension = businessLogoFile.name.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
                toast.error(`Invalid file type: .${fileExtension}. Please upload an image (jpg, jpeg, png).`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    if (img.naturalWidth === 200 && img.naturalHeight === 200) {
                        setBusinessLogoPreview(URL.createObjectURL(businessLogoFile));
                        setProfileUpdateFormData(prev => ({
                            ...prev,
                            business_logo: {
                                file: businessLogoFile,
                            }
                        }));
                    } else {
                        toast.error(`Invalid image dimensions: ${img.naturalWidth}x${img.naturalHeight}. Please upload an image of size 200x200.`);
                    }
                }
                img.src = e.target.result;
            }
            reader.readAsDataURL(businessLogoFile);
        }
    }

    const validateField = (name, value) => {
        let error = "";
        if (name === "business_name") {
            if (!value) {
                error = "Business name is required";
            } 
        }
        if (name === "primary_contact") {
            if (!value) {
                error = "Primary contact is required";
            } 
        }
        if (name === "business_address") {
            if (!value) {
                error = "Business address is required";
            } 
        }
        if(
            profileUpdateFormData.old_password !== '' || 
            profileUpdateFormData.new_password !== '' || 
            profileUpdateFormData.confirm_password !== ''
        ){
            if(name === 'old_password'){
                if (!value) {
                    error = "Old password is required";
                }
            }
            if(name === 'new_password'){
                if (!value) {
                    error = "New password is required";
                }
                else if(profileUpdateFormData.confirm_password !== ''){
                    if(value !== profileUpdateFormData.confirm_password){
                        setProfileUpdateFormError((prevErrors) => ({
                            ...prevErrors,
                            'confirm_password': `New password and confirmation password doesn't match.`,
                        }));
                    }
                    else{
                        setProfileUpdateFormError((prevErrors) => ({
                            ...prevErrors,
                            'confirm_password': ``,
                        }));
                    }
                }
            }
            if(name === 'confirm_password'){
                if (!value) {
                    error = "Confirm password is required";
                }
                else if(value !== profileUpdateFormData.new_password){
                    error = "New password and confirmation password doesn't match.";
                }
            }
        }

        return error;
    }

    const inputChangeHandler = (event) => {
        const { name, value } = event.target;
        const fieldError = validateField(name, value);
        setProfileUpdateFormError((prevErrors) => ({
            ...prevErrors,
            [name]: fieldError,
        }));
        let fieldValue = value;
        if (name === 'primary_contact' || name === 'secondary_contact'){
            fieldValue = value.replace(/\D/g, '');
        }
        setProfileUpdateFormData((prevData) => ({
            ...prevData,
            [name]: fieldValue,
        }));
    }
    const businessUpdateOnClick = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in profileUpdateFormData) {
            newErrors[key] = validateField(key, profileUpdateFormData[key]);
        }
        setProfileUpdateFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setButtonLoader(true)
            let apiToken = '';
            if(loginUserType === 'A') {
                apiToken = localStorage.getItem('token')
            } else if(loginUserType === 'D') {
                apiToken = localStorage.getItem('developertoken')
            } else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }
            const api_headers = {
                headers: { 
                    'Content-Type': 'multipart/form-data',
                    "x-access-token" : apiToken
                }
            };

            let uploadData = new FormData();
            if (
                profileUpdateFormData.business_logo &&
                profileUpdateFormData.business_logo.file
            ) {
                uploadData.append("business_logo", profileUpdateFormData.business_logo.file);
            }
            uploadData.append("business_name", profileUpdateFormData.business_name);
            uploadData.append("primary_contact", profileUpdateFormData.primary_contact);
            uploadData.append("secondary_contact", profileUpdateFormData.secondary_contact);
            uploadData.append("old_password", profileUpdateFormData.old_password);
            uploadData.append("new_password", profileUpdateFormData.new_password);
            uploadData.append("business_address", profileUpdateFormData.business_address);

            uploadData.append("old_business_logo", JSON.stringify(profileUpdateFormData.old_business_logo));

            await axios.post(`${api_base_url}admin/update-business-profile`, uploadData, api_headers)
            .then(async (res) => {
                setButtonLoader(false)
                if(res.data.status === 'success') {
                    toast.success(res.data.message);
                    props.setIsUpdate(false)
                    profileUpdateFormData.business_logo = res.data.data.file_path
                    props.profileFormData(profileUpdateFormData)
                } else if(res.data.status === 'error') {
                    toast.error(res.data.message);
                }
            })
            .catch((error) => {
                setButtonLoader(false)
                console.error(error);
            })
        }
    }

    useEffect(() => {
        if(Object.keys(profileData).length > 0){
            setProfileUpdateFormData(prev => ({
                ...prev,
                business_name: profileData.business_name,
                business_email: profileData.biz_email,
                primary_contact: profileData.biz_phone,
                secondary_contact: profileData.secondary_contact ? profileData.secondary_contact : '',
                business_address: profileData.business_address ? profileData.business_address : '',
                old_business_logo: profileData.biz_logo
            }));
            if(profileData.biz_logo){
                setBusinessLogoPreview(profileData.biz_logo?.full_path)
            }
        }
    },[profileData])

    return (
        <>
            <div className="row">
                <div className="col-md-12 mb-5">
                    <div className="card mb-5 mb-xl-10">
                        <div className="card-header border-0">
                            <div className="card-title m-0">
                                <h3 className="fw-bold m-0 fs-2">Update Business Details</h3>
                            </div>
                        </div>
                        <div className='card-body pt-0'>
                            <div className="row mb-6">
                                <label className="col-lg-4 col-form-label fw-semibold fs-6">
                                    Business Logo
                                </label>
                                <div className="col-md-2">
                                    <label className="form-label">&nbsp;</label>
                                    <div className="card-body border border-dashed border-gray-300 d-flex text-center flex-column bg-light p-5 align-items-center position-relative">
                                        {
                                            !businessLogoPreview ? 
                                            <a
                                                className="text-gray-800 d-flex flex-column cursor-pointer"
                                                onClick={(e) => { e.preventDefault(); selectBusinessLogoHandler() }}
                                            >
                                                <div className="symbol symbol-60px mb-2">
                                                    <span className="svg-icon svg-icon-muted svg-icon-3hx">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </span>
                                                </div>
                                                <div className="text-primary">
                                                    (200 X 200 image are accepted)
                                                </div>
                                            </a>
                                            :
                                            <>
                                                <FontAwesomeIcon
                                                    icon={faXmark} 
                                                    style={{marginLeft:'100%', position:'absolute', top:'5', right:'5'}} 
                                                    className='fs-3 text-gray-600 cursor-pointer' 
                                                    onClick={() => {
                                                        setBusinessLogoPreview('')
                                                        setProfileUpdateFormData(prev => ({
                                                            ...prev,
                                                            business_logo: {},
                                                            old_business_logo: {}
                                                        }));
                                                    }}
                                                />
                                                <img
                                                    src={businessLogoPreview}
                                                    alt="Selected"
                                                    className="w-100"
                                                    style={{ height: "95px", objectFit: "contain" }}
                                                /> 
                                            </>
                                        }
                                        <input
                                            type="file" 
                                            className="d-none"
                                            ref={businessLogoInputRef}
                                            onChange={businessLogoOnChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-6">
                                <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                                    Business Name
                                </label>
                                <div className="col-lg-8">
                                    <div className="row">
                                        <div className="col-lg-12 fv-plugins-icon-container">
                                            <input
                                                type="text" 
                                                name="business_name" 
                                                className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Enter business name"
                                                onChange={inputChangeHandler}
                                                value={profileUpdateFormData.business_name}
                                            />
                                            {profileUpdateFormError.business_name && 
                                                <ValidationMessage 
                                                    className='text-danger' 
                                                    message ={profileUpdateFormError.business_name}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-6">
                                <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                                    Business Email
                                </label>
                                <div className="col-lg-8">
                                    <div className="row">
                                        <div className="col-lg-12 fv-plugins-icon-container">
                                            <input 
                                                type="text" 
                                                name="business_email" 
                                                className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Enter business email" 
                                                value={profileUpdateFormData.business_email}
                                                disabled={true}
                                            />
                                            {profileUpdateFormError.business_email && 
                                                <ValidationMessage 
                                                    className='text-danger' 
                                                    message ={profileUpdateFormError.business_email}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-6">
                                <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                                    Business Primary Contact
                                </label>
                                <div className="col-lg-8">
                                    <div className="row">
                                        <div className="col-lg-12 fv-plugins-icon-container">
                                            <input
                                                type="text" 
                                                name="primary_contact"
                                                className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Enter primary contact"
                                                onChange={inputChangeHandler}
                                                value={profileUpdateFormData.primary_contact}
                                            />
                                            {profileUpdateFormError.primary_contact && 
                                                <ValidationMessage 
                                                    className='text-danger' 
                                                    message ={profileUpdateFormError.primary_contact}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-6">
                                <label className="col-lg-4 col-form-label fw-semibold fs-6">
                                    Business Secondary Contact
                                </label>
                                <div className="col-lg-8">
                                    <div className="row">
                                        <div className="col-lg-12 fv-plugins-icon-container">
                                            <input 
                                                type="text" 
                                                name="secondary_contact" 
                                                className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Enter secondary contact"
                                                onChange={inputChangeHandler}
                                                value={profileUpdateFormData.secondary_contact}
                                            />
                                            {profileUpdateFormError.secondary_contact && 
                                                <ValidationMessage 
                                                    className='text-danger' 
                                                    message ={profileUpdateFormError.secondary_contact}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-6">
                                <div className='col-md-4'>
                                    <label className="col-form-label required fw-semibold fs-6 pb-0">
                                        Password
                                    </label>
                                    <span className="text-gray-400 d-block">
                                        If you want to change your password, please fill in the form.
                                    </span>
                                </div>
                                <div className="col-lg-8">
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <div className="input-group input-group-solid">
                                                <input
                                                    type="text" 
                                                    className={`form-control ${!showOld && 'inp-secure'}`} 
                                                    placeholder="Enter old password"
                                                    name="old_password"
                                                    onChange={inputChangeHandler}
                                                    value={profileUpdateFormData.old_password}
                                                />
                                                <span className="input-group-text">
                                                    <FontAwesomeIcon
                                                        icon={showOld ? faEyeSlash : faEye}
                                                        className='fs-4 cursor-pointer text-gray-500'
                                                        onClick={()=> setShowOld(!showOld)}
                                                    />
                                                </span>
                                            </div>
                                            {profileUpdateFormError.old_password && 
                                                <ValidationMessage 
                                                    className='text-danger' 
                                                    message ={profileUpdateFormError.old_password}
                                                />
                                            }
                                        </div>
                                        <div className='col-md-4'>
                                            <div className="input-group input-group-solid">
                                                <input
                                                    type="text" 
                                                    className={`form-control ${!showNew && 'inp-secure'}`}
                                                    placeholder="Enter new password"
                                                    name="new_password"
                                                    onChange={inputChangeHandler}
                                                    value={profileUpdateFormData.new_password}
                                                />
                                                <span className="input-group-text">
                                                    <FontAwesomeIcon
                                                        icon={showNew ? faEyeSlash : faEye}
                                                        className='fs-4 cursor-pointer text-gray-500'
                                                        onClick={()=> setShowNew(!showNew)}
                                                    />
                                                </span>
                                            </div>
                                            {profileUpdateFormError.new_password && 
                                                <ValidationMessage 
                                                    className='text-danger' 
                                                    message ={profileUpdateFormError.new_password}
                                                />
                                            }
                                        </div>
                                        <div className='col-md-4'>
                                            <div className="input-group input-group-solid">
                                                <input 
                                                    type="text"
                                                    className={`form-control ${!showConfirm && 'inp-secure'}`}
                                                    placeholder="Enter confirm password"
                                                    name="confirm_password"
                                                    onChange={inputChangeHandler}
                                                    value={profileUpdateFormData.confirm_password}
                                                />
                                                <span className="input-group-text">
                                                    <FontAwesomeIcon
                                                        icon={showConfirm ? faEyeSlash : faEye}
                                                        className='fs-4 cursor-pointer text-gray-500'
                                                        onClick={()=> setShowConfirm(!showConfirm)}
                                                    />
                                                </span>
                                            </div>
                                            {profileUpdateFormError.confirm_password && 
                                                <ValidationMessage 
                                                    className='text-danger' 
                                                    message ={profileUpdateFormError.confirm_password}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-6">
                                <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                                    Business Address
                                </label>
                                <div className="col-lg-8">
                                    <div className="row">
                                        <div className="col-lg-12 fv-plugins-icon-container">
                                            <textarea
                                                className="form-control form-control-solid" 
                                                rows="5"
                                                placeholder='Enter business address'
                                                name="business_address"
                                                onChange={inputChangeHandler}
                                                value={profileUpdateFormData.business_address}
                                            >
                                            </textarea>
                                            {profileUpdateFormError.business_address && 
                                                <ValidationMessage 
                                                    className='text-danger' 
                                                    message ={profileUpdateFormError.business_address}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12 text-end'>
                                    <button 
                                        type="button" 
                                        className="btn btn-light btn-active-light-primary me-2"
                                        onClick={() => props.hideUpdateForm(false)}
                                    >
                                        Discard
                                    </button>
                                    <div
                                        className={`btn btn-primary ${buttonLoader && 'disabled'}`}
                                        onClick={businessUpdateOnClick}
                                    >
                                        {
                                            buttonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 'Save Changes'
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BusinessInfoUpdateForm